/****************** Archive Management ****************************/
export const RESET_ARCHIVAL_MANAGEMENT = "RESET_ARCHIVAL_MANAGEMENT";
export const SET_PROCESSING_ARCHIVAL_MANAGEMENT =
  "SET_PROCESSING_ARCHIVAL_MANAGEMENT";
export const STOP_PROCESSING_ARCHIVAL_MANAGEMENT =
  "STOP_PROCESSING_ARCHIVAL_MANAGEMENT";
export const LOAD_CHANNEL = "LOAD_CHANNEL";
export const STOP_LOAD_CHANNEL = "STOP_LOAD_CHANNEL";
export const GET_CHANNEL = "GET_CHANNEL";
export const UPDATE_CHANNEL = "UPDATE_CHANNEL";
export const CREATE_CHANNEL = "CREATE_CHANNEL";

/****************** BANK SETTINGS ********************************/
export const RESET_BANK_SETTINGS = "RESET_BANK_SETTINGS";
export const SET_PROCESSING_BANK_SETTINGS = "SET_PROCESSING_BANK_SETTINGS";
export const STOP_PROCESSING_BANK_SETTINGS = "STOP_PROCESSING_BANK_SETTINGS";
export const LOAD_CONFIGURATION = "LOAD_CONFIGURATION";
export const STOP_LOAD_CONFIGURATION = "STOP_LOAD_CONFIGURATION";
export const GET_CURRENCIES = "GET_CURRENCIES";
export const GET_CONFIGURATION = "GET_CONFIGURATION";
export const UPDATE_CONFIGURATION = "UPDATE_CONFIGURATION";
export const CREATE_CONFIGURATION = "CREATE_CONFIGURATION";
export const TOGGLE_UAT = "TOGGLE-UAT";
export const SEND_TEST_EMAIL = "SEND_TEST_EMAIL";
export const SET_SENDING_TEST_EMAIL = "SET_SENDING_TEST_EMAIL";

/****************** ALERTS ********************************/

export const LOAD_ALERTS = "LOAD_CHANNEL";
export const GET_ALERT = "GET_ALERT";
export const LOAD_NOTIFICATIONS = "LOAD_ALERT";
export const LOAD_SMS = "LOAD_ALERT";
export const RESET_ALERTS = "RESER_ALERTS";
export const UPDATE_ALERT = "UPDATE_ALERT";
export const DELETE_ALERT = "DELETE_ALERT";
export const CREATE_ALERT = "CREATE_ALERT";
export const FILTER_DATA = "FILTER_DATA";
export const UPDATE_DEFAULT = "UPDATE_DEFAULT";
export const CUSTOMER_FILE = "CUSTOMER_FILE";
export const FAILED_CUSTOMERS = "FAILED_CUSTOMERS";
export const ALL_GROUPS = "ALL_GROUPS";
